"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* [DISABLED_TEMPORARILY] @ typescript-eslint /camelcase */
var productListingConfig = [
    // {
    //     key: 'so',
    //     type: 'so',
    //     label_ar: 'Search URL',
    //     label_en: 'Search URL',
    //     required: true,
    // },
    // Making it virtual for the time being
    {
        key: 'moduleHeader',
        type: 'group',
        label_ar: 'Module Header',
        label_en: 'Module Header',
        required: false,
        is_virtual: true,
        values: [
            {
                key: 'titleText',
                type: 'string',
                label_ar: 'Title Text',
                label_en: 'Title Text',
                required: false,
            },
            {
                key: 'titleColor',
                type: 'color',
                label_ar: 'Title Text Color',
                label_en: 'Title Text Color',
                required: false,
            },
            {
                key: 'linkText',
                type: 'string',
                label_ar: 'CTA Text',
                label_en: 'CTA Text',
                required: false,
            },
            {
                key: 'linkUrl',
                type: 'url',
                label_ar: 'CTA Url',
                label_en: 'CTA Url',
                required: false,
            },
            {
                key: 'textColor',
                type: 'color',
                label_ar: 'CTA Text Color',
                label_en: 'CTA Text Color',
                required: false,
            },
            {
                key: 'linkBgColor',
                type: 'color',
                label_ar: 'CTA Background Color',
                label_en: 'CTA Background Color',
                required: false,
            },
            // Not including this, do not like image in header
            // Just make another banner widget
            {
                key: 'titleImageUrl',
                type: 'image',
                label_ar: 'Title Image',
                label_en: 'Title Image',
                required: false,
                is_virtual: true,
            },
        ],
    },
    {
        key: 'search',
        type: 'search_object',
        required: true,
        sort: 1,
        label_ar: 'Search URL',
        label_en: 'Search URL',
        description_ar: 'Check out All Products to view the products currently live, and copy the link here after applying filters<br/>or you can do the same below, and the link will be automatically generated<br/><strong>Note:</strong>Your URL may look different after saving, but it will show the same products',
        description_en: 'Check out All Products to view the products currently live, and copy the link here after applying filters<br/>or you can do the same below, and the link will be automatically generated<br/><strong>Note:</strong>Your URL may look different after saving, but it will show the same products',
    },
    {
        key: 'grid',
        type: 'boolean',
        label_ar: 'Grid',
        label_en: 'Grid',
        required: false,
        is_virtual: true,
    },
    {
        key: 'name',
        type: 'string',
        label_ar: 'Name',
        label_en: 'Name',
        required: true,
        default_value: 'plp',
        is_virtual: true,
    },
];
exports.default = productListingConfig;
//# sourceMappingURL=config.js.map